/**
 * Niveaux de visibilité d'un contenu pédagogique.
 *
 * Hiérarchie (du plus restrictif au plus ouvert):
 * PRIVATE < CLASS < ESTABLISHMENT < PUBLIC
 */
export enum ActivityVisibility {
  /**
   * Privé - Visible uniquement par l'auteur
   */
  PRIVATE = 'PRIVATE',

  /**
   * Classe - Visible par les classes assignées
   * Requiert une assignation explicite
   */
  CLASS = 'CLASS',

  /**
   * Établissement - Visible par tous les membres de l'établissement
   */
  ESTABLISHMENT = 'ESTABLISHMENT',

  /**
   * Public - Visible par tous (inter-établissement)
   */
  PUBLIC = 'PUBLIC',
}

